import { createSlice } from '@reduxjs/toolkit';
import {
  DEFAULT_STATUS_FILTER_PACKAGE_WITH_PAQUERS,
  DEFAULT_STATUS_FILTER_PACKAGE,
  DEFAULT_PACKAGE_TYPE,
} from 'constants/defaultValues';

export const initialState = {
  isLoading: false,
  avatar: {
    name: undefined,
    data: undefined,
  },
  driverId: null,
  packages: {
    items: [],
    pageable: {
      pageSize: 10,
      pageNumber: 0,
      totalElements: 0,
    },
    marketplaceId: '',
    type: DEFAULT_PACKAGE_TYPE,
    status: DEFAULT_STATUS_FILTER_PACKAGE_WITH_PAQUERS,
    sort: '',
    search: '',
    date: {
      from: '',
      to: '',
    },
    loaded: true,
  },
  history: {
    items: [],
    pageable: {
      pageSize: 10,
      pageNumber: 0,
      totalElements: 0,
    },
    marketplaceId: '',
    type: DEFAULT_PACKAGE_TYPE,
    status: DEFAULT_STATUS_FILTER_PACKAGE,
    sort: '',
    search: '',
    date: {
      from: '',
      to: '',
    },
    loaded: true,
  },
};

const paquerViewSlice = createSlice({
  name: 'paquer-view',
  initialState,
  reducers: {
    setDriverId: (state, action) => {
      state.driverId = action.payload;
    },
    loading: (state) => {
      state.isLoading = true;
    },
    loaded: (state) => {
      state.isLoading = false;
    },
    setAvatar: (state, action) => {
      state.avatar = action.payload;
    },
    fetchPackages: (state) => {
      state.packages.loaded = false;
    },
    fetchPackagesSuccess: (state, action) => {
      state.packages.items = action.payload.items;
      state.packages.pageable.totalElements = action.payload.total;
      state.packages.loaded = true;
    },
    fetchPackagesFailure: (state) => {
      state.packages.loaded = true;
    },
    fetchHistory: (state) => {
      state.history.loaded = false;
    },
    fetchHistorySuccess: (state, action) => {
      state.history.items = action.payload.items;
      state.history.pageable.totalElements = action.payload.total;
      state.history.loaded = true;
    },
    fetchHistoryFailure: (state) => {
      state.history.loaded = true;
    },
    reset: () => initialState,
    updateSearchPackages: (state, action) => {
      state.packages.pageable.pageNumber = 0;
      state.packages.search = action.payload;
    },
    updateSortPackages: (state, action) => {
      state.packages.sort = action.payload;
    },
    updatePaginationPackages: (state, action) => {
      state.packages.pageable.pageNumber =
        action.payload.pageSize !== state.packages.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.packages.pageable.pageSize = action.payload.pageSize;
    },
    updatePackageType: (state, action) => {
      state.packages.type = action.payload;
    },
    updateStatus: (state, action) => {
      state.packages.status = action.payload;
      state.packages.pageable.pageNumber = 0;
    },
    updateMarket: (state, action) => {
      state.packages.pageable.pageNumber = 0;
      state.packages.marketplaceId = action.payload;
    },
    updateDate: (state, action) => {
      state.packages.date = action.payload;
      state.packages.pageable.pageNumber = 0;
    },
    removePacket: (state, action) => {
      state.packages.items.forEach((packet) => {
        if (packet.id === action.payload) {
          state.packages.items.splice(state.packages.items.indexOf(packet), 1);
        }
      });
    },
    updateSearchHistory: (state, action) => {
      state.history.pageable.pageNumber = 0;
      state.history.search = action.payload;
    },
    updateSortHistory: (state, action) => {
      state.history.sort = action.payload;
    },
    updatePaginationHistory: (state, action) => {
      state.history.pageable.pageNumber =
        action.payload.pageSize !== state.history.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.history.pageable.pageSize = action.payload.pageSize;
    },
    updateHistoryType: (state, action) => {
      state.history.type = action.payload;
    },
    updateStatusHistory: (state, action) => {
      state.history.status = action.payload;
      state.history.pageable.pageNumber = 0;
    },
    updateMarketHistory: (state, action) => {
      state.history.pageable.pageNumber = 0;
      state.history.marketplaceId = action.payload;
    },
    updateDateHistory: (state, action) => {
      state.history.date = action.payload;
      state.history.pageable.pageNumber = 0;
    },
    // Solo disparan la saga; el spinner lo prende fetchHistory/fetchPackages
    // cuando el pedido arranca de verdad. Si lo prendieran acá, quedaría
    // colgado cuando updateBasefilters corta por filtros sin cargar (sin fecha).
    refreshPageHistory: () => {},
    refreshPagePackages: () => {},
  },
});

export const { name, actions, reducer } = paquerViewSlice;
